import React, {Fragment} from 'react';
// eslint-disable-next-line import/extensions
import {connect} from 'redux-zero/react';
import {injectIntl} from 'react-intl';
import {Helmet} from 'react-helmet';
import cn from 'classnames';

import {withLocaleContext} from '../../locales/locale-context.js';
import {prefixPathWithLocale} from '../../locales/locale-paths.js';
import {actions} from '../../shared/store.js';
import {shuffleArr} from '../../shared/utils.js';
import PageHeader from '../../components/page-header/page-header.component.js';
import NotImplemented from '../../components/not-implemented/not-implemented.js';
import Step from '../../components/step/step.component.js';
import InfoBubbles from '../../components/info-bubbles/info-bubbles.component.js';
import IconLabel from '../../components/icon-label/icon-label.component.js';
import ParkService from './park.service.js';
import ImageMap from '../../components/image-map/image-map.js';
import Question from '../../components/question/question.js';

import questionsImage from '../../assets/images/park/bg.jpg';
import LaboratoriesSVG from '../../assets/icons/park/laboratories/laboratoriesSVG.js';
import FacilitiesSVG from '../../assets/icons/park/facilities/facilitiesSVG.js';
import RestaurantSVG from '../../assets/icons/park/restaurant/restaurantSVG.js';
import LoungeSVG from '../../assets/icons/park/lounge/loungeSVG.js';
import MealsSVG from '../../assets/icons/park/meals/mealsSVG.js';
import ParkingSVG from '../../assets/icons/park/parking/parkingSVG.js';
import parkImage from '../../assets/images/park/park-map.jpg';

import './park.scss';
import '../../styles/video-player.scss';
import '../../components/ui-toolkit/buttons.scss';

const biocantMapping = [
	{
		id: 'biocant1',
		path:
			'M647.34 192.44c-3.55-3.54-8.9-7.94-8.9-7.94L686 172.63l20-4.15 14.53 5.83 15.91 7.88 16.21-5.54s2.92.39 4.09.87c6.2-1.52 16.08-4.97 16.08-4.97s13.61 5.86 14.68 5.7c6.61-2.35 17.37-5.42 17.37-5.42l20.83-6.31 15.26 4.18s19.51 5.92 28.88 8.68c3.22.87 2.04 1.9 2.04 1.9L838 193c2.61 2.66 6.12 5.37 10 5.61 3.56.21 6.92-1.99 12-1.27l37 13.08c3.1 1.17 11.72 3.64 13.56 5.61.38 2.85.71 11.88.72 15.13L912 247l.31 12.06L863 274.98 769 305l-41 13.33c-3.67 1.2-17.02 5.62-20 5.36-3.12-.28-8.93-3.87-12-5.45l-26-14-10-5.07c-6.23-1.58-18 6.69-24 4.9-2.97-.89-12.6-6.09-13.84-8.85-1.41-5.44 1.84-12.28-4.35-14.41l-30.33-15.77c-2.63-2.44-3.14-8.54-3.9-12.04L577 221l20-5.98L652 198s-1.44-2.36-4.66-5.56z',
		place: 'left',
		position: {top: '23%', right: '73%'}
	},
	{
		id: 'biocant2',
		path:
			'M882 334l55-19.31 78-27.38 58-20.64c5.95-2.01 25.2-9.49 30-9.49 3.95 0 14.68 4.05 19 5.49l36 11.66 114 37 46 15c3.17 1.06 15.74 4.53 17.36 6.37 2.21 2.49-.43 15.6-.94 19.3l-5.42 43c-.45 3.28-1.77 16.65-3.02 18.62-1.41 2.23-5.65 4.34-7.98 5.61l-16 9.05-60 33.72-85 47.86-25 14.14c-2.55 1.47-9.51 5.78-12 6.14-3.07.46-6.33-1.57-9-2.89l-16-8-65-32.5-18-9c-2.87-1.42-5.67-3.23-9-2.58-2.86.56-7.47 3.84-11 4.4-4.45.71-12.61-4.04-17-5.99-2.05-.92-4.72-2-5.98-3.97-3.35-5.25 3.09-11.08-7.02-16.81l-18-9.05-35-17.5c-4.01-2.01-19.05-8.73-20.99-11.64-2.5-3.73-1.79-14.71-2.43-19.61l-.67-12-2.91-49z',
		place: 'bottom',
		position: {top: '52%', left: '52%'}
	},
	{
		id: 'biocant3',
		path:
			'M491 478l17-6.42 44-16 16-5.9c2.65-.97 6.14-2.36 8.96-1.81 4.08.79 16.6 11.11 20.74 14.13l50.13 37.13L745.91 571 776 592.63c3.54 2.62 12.12 8.25 14.26 11.46 1.98 2.96 2.33 12.06 2.91 16l4.96 35.91 4.74 35.35c.47 3.17 1.85 12.05.65 14.65-1.06 2.32-5.23 4.27-7.52 5.58l-22.26 11.99-82.61 46.04L464.83 896l-75.18 42.13-38.3 21.26c-3.07 1.14-5.79.17-8.83-.48-2.27-.59-4.04-.56-5.87-2-2.87-2.26-10.4-18.25-12.74-22.43l-54.82-95.44L236.31 779l-7.57-16.17-5-4.66-28.78-50.26-.57-4.56s-1.25-1.4-2.68-4.51c-1.73-3-.53-5.82-3.53-10.11-4.28-10.84-11.43-23.73-11.43-23.73l-20.5-42.81c-1.99-3.54-8.26-13.14-6.47-16.88 2.14-4.47 17.36-8.44 22.28-10.31l65.25-23.84 10.08-3.49s26.77-9.86 28.33-10.83c2.42-.82 4.1-1.19 6.1-1.86l29.68-11.26c5.72-2.22 8.46-2.48 11.77-4.96-.38-2.36.39-2.77.84-4.2l55.17-19.65 13.86-.07 8.84-3.72c-.17-2.03-4.17-4.31-3.62-6.4.97-1.13 10.14-4.47 12.55-3.92 3.77.86 2.18 5.74 7.54 4.67l18.55-7.42L469 486c8.94-2.14 6.09-4.86 12.67-11.61 1.65-1.61 5.23-3.52 7.66-2.64 2.49.9 1.6 4.12 1.67 6.25zm-71.02 26.17',
		place: 'bottom',
		position: {top: '85%', left: '20%'}
	},
	{
		id: 'headquarters',
		path:
			'M895.97 102.29c2.26-2.66 23.94-5.48 28.96-6.49-.01-.01 24.3-5.81 25.76-5.68 8.54.87 28.94 9.32 34.04 11.72l22.36-5.5c8.1.85 13.32 4.69 19.44 3.6l34.57-10.51c3.19-.17 13.51 2.64 17.19 3.28 17.9 3.2 33.87 3.79 34.75 5.98-.98 4.12-3.23 1.85-11.17 4.61l-12.77 4.86 5.18 6.27 10.82 3.6 24 5.75 17.59 4.47-.03 7.97.31 39-.03 6.56-19.84 7.37-22.79 7.47c-1.18.37-1.88 2.37-3.07 2.26-.94.48-3.82-.17-4.4.34l-26.74 9.94c2.9.68 8.21 2.04 11.03 1.71 7.28-.86 16.76-5.78 24.15-4.92 4.5.53 7.35 2.12 11.08 4.49 7.95 5.06 8.91 5.11 9.06 13.12.09 2.64.36 11.78.17 13.63-2.43 1.75-8.77 4.18-10.97 4.93-4.88 1.68-11.59 3.82-15.52 4.09l-18-5.72-55-18.54c-8.47-1.76-23.72 8.01-32 6.65l-31-9.73-75-23.43-26.83-8.93c.86-2.73 7.62-2.69 10.66-5.04-.93-3.02-7.55-2.85-12.83-5.31l-2-34c-.01-2.86-1.4-10.14.59-11.84 1.29-1.12 8.34-2.52 10.41-3.04l34.02-7.39c.05-3.07-.68-4.92 1.52-5.8 3.01-1.08 9.46-2.25 12.46-2.93.11.06.38-1.41-.09-2.66-8.44-3.91-20.04-6.21-20.04-6.21z',
		place: 'right',
		position: {top: '15%', left: '54%'}
	},
	{
		id: 'biotech',
		path:
			'M1479 479c-2.22-4.87-5.74-2.68-7.91-3.91-2-3.44-4.57-7.83 2.39-8.44l20.22-15.52 86.91-61.26L1720 290.58l40.19-27.96c3.38-2.4 13.9-10.28 17.12-11 2.93-.64 9.63 1.88 12.5 2.69l49.13 13.38s27.52 5.47 27.81 7.31c-1.8 4.49-9.75 9.18-5.06 12.69 4.83 6.46 16.02 7.95 23.31 10.02 2.44.69 10.91 2.69 13.16 2.57 4.08-.22 1.17-3.7 6.12-3.4l19.72 4.75 32.96 8.05c4.08 1.39 2.98 2.76 6.54 4.38l14.22 4.1c7.99 2.14 9.26-.24 13.31.4 4.71 1.17.45 4.13 9.41 6.35 7.03.97 17.94 1.53 11.9 7.93 0-.11 4.44-.34 3.72.54-1.24 8.12-4.62 6.26-8.01 13.48l2 1.31-.03 2.75c-8.08 5.86-4.82 8.16-8.56 16.08l-5.95 11c-.91 3.08-.71 5.37-2.13 8.69l-6.76 9.92c-1.17 2.85.42 5.16-.92 8.5l-15.4 20.5-30.18 44.45L1795 676l-41.75 60.31L1728 775c-6.96-1.99-17.19-9.32-24.38-12.62l-59.18-28.44-88.44-41.68-88.5-43.45-53.56-26.12c-3.67-1.84-19.31-7.56-20.92-10.08-1.59-2.49-1.17-14.89-1.11-18.48-.21-7.87 4.39-9.39 15.57-16.39l27.52-17.16c3.44-1.98 11.99-6.47 13.81-9.83 2.88-3.37 1.6-15.45 2.35-19.69 1.04-5.89 3.41-3.33 5.14-6.89 1.62-3.3-2.26-3.68.7-8.91 3.13-5.53 7.91-8.53 13-11.93 1.72-1.15 7.77-4.72 8.6-6.46 2.13-4.47-9.11-5.61-10.69-8.25-1.8-3.78 10.25-7.48 11.09-9.62z',
		place: 'bottom',
		position: {top: '68%', left: '83%'}
	}
];

class ParkPage extends React.Component {
	static prefetchData = async language => ParkService.getParkPageData(language);

	state = {
		activeQuestion: -1,
		videoOpen: false
	};

	componentDidMount() {
		const {parkPageData, setLoading} = this.props;
		if (!parkPageData) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const {
			localeContext: {locale}
		} = this.props;

		if (prevProps.localeContext.locale.value !== locale.value) {
			this.fetchData();
		}
	}

	handleAnswer(answer) {
		const {activeQuestion} = this.state;

		if (answer === activeQuestion) {
			this.setState({activeQuestion: -1});
			return;
		}

		this.setState({activeQuestion: answer});
	}

	toggleVideo = () => {
		if (!this.state.videoOpen) {
			document.getElementsByTagName('body')[0].className = 'full-screen';
		} else {
			document.getElementsByTagName('body')[0].className = '';
		}
		this.setState(prevState => ({videoOpen: !prevState.videoOpen}));
	};

	fetchData() {
		const {
			setLoading,
			setParkPageData,
			localeContext: {locale}
		} = this.props;

		setLoading(true);

		ParkPage.prefetchData(locale.value)
			.then(({data}) => {
				setParkPageData(data);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);

				this.setState({
					hasError: true
				});
			});
	}

	render() {
		const {hasError, activeQuestion, videoOpen} = this.state;
		const {
			isLoading,
			parkPageData,
			intl,
			localeContext: {locale}
		} = this.props;

		if (isLoading) return null;

		if (hasError || !parkPageData) {
			return <NotImplemented/>;
		}

		const {
			title,
			author,
			description,
			parkVideo,
			visionAndMission,
			ourValuesTitle,
			ourValues,
			ourValues_shortText,
			infrastructures,
			parkBuilding,
			companiesInfo,
			industrialResearch,
			parkMap
		} = parkPageData;

		if (!this.shuffledCompanies) {
			this.shuffledCompanies = shuffleArr(companiesInfo.companiesToDisplay);
			if (this.shuffledCompanies.length > 10) {
				this.shuffledCompanies.length = 10;
			}
		}

		return (
			<Fragment>
				<div id="park-page">
					<Helmet>
						<title>
							{intl.formatMessage({
								id: 'navigation.park'
							})}
						</title>
					</Helmet>
					<section className="header">
						<div className="container container-fluid">
							<div className="row">
								<div className="col-xs-12 col-md-5 middle-xs title">
									<div className="container">
										<div className="row">
											<div className="col-xs-12">
												<div className="button-section">
													<PageHeader
														title={intl.formatMessage({
															id: 'park.button-title'
														})}
													/>
												</div>
											</div>
											<div className="col-xs-12">
												<div className="title-label">
													<h2>{title}</h2>
												</div>
											</div>
											<div className="col-xs-12">
												<div className="author-label">
													<h6>{author}</h6>
												</div>
											</div>
											<div className="col-xs-12">
												<div className="description">
													<p>{description}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xs-12 col-md-7 header-image">
									<div className="play-button" onClick={this.toggleVideo}/>
								</div>
							</div>
						</div>
					</section>
					<section className="our-vision-mission">
						<div className="container container-fluid">
							{visionAndMission &&
							visionAndMission.map((step, index) => (
								<Step
									key={step.value.title}
									title={step.value.title}
									description={step.value.description}
									image={step.value.image}
									number={index}
								/>
							))}
						</div>
					</section>
					<section className="our-values">
						<div className="container container-fluid our-values-content">
							<div className="row">
								<div className="col-xs-12 col-md-5">
									<div className="container">
										<div className="row">
											<div className="col-xs-12 questions-section-title">
												<h3>{ourValuesTitle}</h3>
											</div>
											<div className="col-xs-12 questions-section-description">
												<p>{ourValues_shortText}</p>
											</div>
											<div className="col-xs-12 questions-section">
												<div className="container">
													<div className="row">
														<div className="col-xs-12">
															<div className="container questions">
																{ourValues.map((question, index) => (
																	<Question
																		key={question.value.question}
																		question={question.value.question}
																		answer={question.value.answer}
																		index={index}
																		activeQuestion={activeQuestion}
																		handleQuestion={() =>
																			this.handleAnswer(index)
																		}
																	/>
																))}
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xs-12 col-md-6 question-image">
									<img src={questionsImage} alt="Questions"/>
									<div className="fade"/>
								</div>
							</div>
						</div>
					</section>
					<section className="infrastructures">
						<div className="container container-fluid">
							<div className="row infra-text-row">
								<div className="col-xs-12 col-md-3 middle-xs title">
									<h3>
										{intl.formatMessage({
											id: 'park.fourth-section.title'
										})}
									</h3>
								</div>
								<div className="col-xs-12 col-md-8 middle-xs description">
									<p>{infrastructures.generalDescription}</p>
								</div>
							</div>
						</div>
						<div className="container container-fluid icon-container">
							<div className="row infra-icons-row">
								<div className="col-xs-12 col-md-5 middle-xs middle-md infra-icon-col">
									<IconLabel
										key={infrastructures.labsTitle}
										title={infrastructures.labsTitle}
										description={infrastructures.labsDescription}
										svg={<LaboratoriesSVG/>}
									/>
								</div>
								<div className="col-xs-12 col-md-5 middle-xs middle-md infra-icon-col">
									<IconLabel
										key={infrastructures.facilitiesTitle}
										title={infrastructures.facilitiesTitle}
										description={infrastructures.facilitiesDescription}
										svg={<FacilitiesSVG/>}
									/>
								</div>
							</div>
						</div>
					</section>
					<section className="biocant-building">
						<div className="container container-fluid">
							<div className="row text-row">
								<div className="col-xs-12 col-md-12 center-xs center-md title">
									<h3>
										{intl.formatMessage({
											id: 'park.fifth-section.title'
										})}
									</h3>
								</div>
								<div className="col-xs-12 col-md-12 center-xs center-md description">
									<p>{parkBuilding.shortDescription}</p>
								</div>
							</div>
							<div className="row icon-row">
								<div className="box col-xs-12 col-sm-6 col-md-3 center-xs middle-xs">
									<img
										src={process.env.REACT_APP_API_ENDPOINT + parkBuilding.restaurantImage.path}
										alt={parkBuilding.restaurantText}
									/>
									<IconLabel
										key={parkBuilding.restaurantText}
										description={parkBuilding.restaurantText}
										svg={<RestaurantSVG height="60px"/>}
									/>
								</div>
								<div className="box col-xs-12 col-sm-6 col-md-3 center-xs middle-xs">
									<img
										src={process.env.REACT_APP_API_ENDPOINT + parkBuilding.loungeImage.path}
										alt={parkBuilding.loungeText}
									/>
									<IconLabel
										key={parkBuilding.loungeText}
										description={parkBuilding.loungeText}
										svg={<LoungeSVG height="60px"/>}
									/>
								</div>
								<div className="box col-xs-12 col-sm-6 col-md-3 center-xs middle-xs">
									<img
										src={process.env.REACT_APP_API_ENDPOINT + parkBuilding.mealImage.path}
										alt={parkBuilding.mealText}
									/>
									<IconLabel
										key={parkBuilding.mealText}
										description={parkBuilding.mealText}
										svg={<MealsSVG height="60px"/>}
									/>
								</div>
								<div className="box col-xs-12 col-sm-6 col-md-3 center-xs middle-xs">
									<img
										src={process.env.REACT_APP_API_ENDPOINT + parkBuilding.parkingImage.path}
										alt={parkBuilding.parkingText}
									/>
									<IconLabel
										key={parkBuilding.parkingText}
										description={parkBuilding.parkingText}
										svg={<ParkingSVG height="60px"/>}
									/>
								</div>
							</div>
						</div>
					</section>
					<section className="park-companies">
						<div className="container container-fluid">
							{companiesInfo && this.shuffledCompanies && (
								<InfoBubbles
									sectiontitle={intl.formatMessage({
										id: 'park.sixth-section.title'
									})}
									title={companiesInfo.title}
									description={companiesInfo.description}
									link={prefixPathWithLocale(companiesInfo.link, locale)}
									btnLabel={companiesInfo.btnLabel}
									shuffledCompanies={this.shuffledCompanies}
								/>
							)}
						</div>
					</section>
					<section className="ind-zone-research">
						<div className="container container-fluid">
							<div className="row ind-row">
								<div className="col-xs-12 col-md-6 ind-img">
									<img src={process.env.REACT_APP_API_ENDPOINT + industrialResearch.industrialImage.path}
											 alt={industrialResearch.industrialZoneTitle}/>
								</div>
								<div className="col-xs-12 col-md-6 ind-zone">
									<h4 className="text title">
										{industrialResearch.industrialZoneTitle}
									</h4>
									<div
										className="text"
										dangerouslySetInnerHTML={{
											__html: industrialResearch.industrialZone
										}}
									/>
								</div>
							</div>
							<div className="row res-row">
								<div className="col-xs-12 col-md-6 research">
									<h4 className="text title">
										{industrialResearch.researchTitle}
									</h4>
									<div
										className="text"
										dangerouslySetInnerHTML={{
											__html: industrialResearch.research
										}}
									/>
								</div>

								<div className="col-xs-12 col-md-6 res-img">
									<img src={process.env.REACT_APP_API_ENDPOINT + industrialResearch.researchImage.path}
											 alt={industrialResearch.researchTitle}/>
								</div>
							</div>
						</div>
					</section>
					<section className="park-map">
						<div className="container container-fluid">
							<div className="row text-row">
								<div className="col-xs-12 col-md-12 center-xs center-md title">
									<h3>
										{parkMap.title}
									</h3>
								</div>
								<div className="col-xs-12 col-md-12 center-xs center-md description">
									<p>
										<span>{parkMap.description}</span>
										<span>{parkMap.description2}</span>
									</p>
								</div>
							</div>
						</div>
						<ImageMap
							id="parkMapping"
							image={parkImage}
							viewBox="0 0 2140 1024"
							mapping={biocantMapping}
							labels={parkMap}
						/>
					</section>
				</div>
				{parkVideo && (
					<div className={`video-player ${cn({active: videoOpen})} `}>
						<div className="video-wrapper">
							<div className="close-video-player" onClick={this.toggleVideo}/>
							<div className="video">
								{parkVideo && videoOpen && (
									<video controls autoPlay>
										<source
											src={`${process.env.REACT_APP_API_ENDPOINT}/${parkVideo}`}
											type="video/mp4"
										/>
										{'Your browser does not support HTML5 video.'}
									</video>
								)}
							</div>
						</div>
					</div>
				)}
			</Fragment>
		);
	}
}

const mapToProps = ({parkPageData, parkVideo}) => ({
	parkPageData,
	parkVideo
});

export default withLocaleContext(
	injectIntl(connect(mapToProps, actions)(ParkPage))
);

export {ParkPage};
